'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { IconButton } from 'src/components/Atoms/IconButton';
import { AppBar } from 'src/components/Molecules/AppBar';
import Icon from 'src/components/Particles/Icons/Icon';
interface TopBarProps {
  open: boolean;
  disableDrawer?: boolean;
  handleDrawerAction: (open: boolean) => void;
  children?: React.ReactNode;
}
const TopBar: React.FC<TopBarProps> = t0 => {
  const $ = _c(8);
  const {
    open,
    handleDrawerAction,
    children,
    disableDrawer: t1
  } = t0;
  const disableDrawer = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== disableDrawer || $[1] !== handleDrawerAction || $[2] !== open) {
    t2 = disableDrawer ? null : <IconButton onClick={() => handleDrawerAction(!open)}><Icon icon="DockToRight" /></IconButton>;
    $[0] = disableDrawer;
    $[1] = handleDrawerAction;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== open || $[6] !== t2) {
    t3 = <AppBar open={open}>{t2}{children}</AppBar>;
    $[4] = children;
    $[5] = open;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default TopBar;
export type { TopBarProps };